import { appendALExamTemplate } from '@/functions/idp'

import RIC from './RIC_13'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
